import * as baseValidations from './BaseValidator'

export function validatePassword(data: any) {
    if (!baseValidations.IsPresent(data)) {
        return {
            isValid: false,
            errorMessage: 'required'
        }
    } else if (!baseValidations.minLength(data, 6)) {
        return {
            isValid: false,
            errorMessage: 'is too short (minimum is 6 characters)'
        }
    } else {
        return { isValid: true, errorMessage: '' }
    }
}

export function validateEmail(data: string) {
    if (!baseValidations.IsPresent(data)) {
        return {
            isValid: false,
            errorMessage: "Email can't be blank"
        }
    } else if (!baseValidations.IsValidEmail(data)) {
        return {
            isValid: false,
            errorMessage: 'Email is invalid'
        }
    } else {
        return {
            isValid: true,
            errorMessage: "Email can't be blank"
        }
    }
}

export function validateUserPassword(data: string) {
    if (!baseValidations.IsPresent(data)) {
        return {
            isValid: false,
            // errorMessage: `${i18next.t('sign_up.error_required_pswrdmessage')}`
            errorMessage: "Password can't be blank"
        }
    } else if (!baseValidations.minLength(data, 6)) {
        return {
            isValid: false,
            // errorMessage: `${i18next.t('sign_up.password_length_error_message')}`
            errorMessage: 'Password is too short (minimum is 6 characters)'
        }
    } else {
        return { isValid: true, errorMessage: '' }
    }
}

export function validateSignupEmail(data: string) {
    if (!baseValidations.IsPresent(data)) {
        return {
            isValid: false,
            // errorMessage: `${i18next.t('sign_up.error_required_message')}`
            errorMessage: "Email can't be blank"
        }
    } else if (!baseValidations.IsValidEmail(data)) {
        return {
            isValid: false,
            // errorMessage: `${i18next.t('sign_up.invalid_email_error_message')}`
            errorMessage: 'Email is invalid'
        }
    } else {
        return {
            isValid: true,
            // errorMessage: `${i18next.t('sign_up.error_required_messages')}`
            errorMessage: "Email can't be blank"
        }
    }
}

export function RequiredValidation(data: string) {
    if (!baseValidations.IsPresent(data)) {
        return {
            isValid: false,
            errorMessage: 'required'
        }
    } else {
        return { isValid: true, errorMessage: '' }
    }
}

export function ValidateNumber(data: string | undefined) {
    if (data !== undefined && data !== '' && data.trim() !== '' && data.trim().length > 0) {
        if (isNaN(+data)) {
            return {
                isValid: false,
                errorMessage: 'is invalid'
            }
        } else {
            return { isValid: true, errorMessage: '' }
        }
    } else {
        return { isValid: true, errorMessage: '' }
    }
}
export function validateFirstName(data: string) {
    if (!baseValidations.IsPresent(data)) {
        return {
            isValid: false,
            errorMessage: 'required'
        }
    } else {
        return { isValid: true, errorMessage: '' }
    }
}

export function validateForgetPassword(data: string) {
    if (!baseValidations.IsPresent(data)) {
        return {
            isValid: false,
            errorMessage: "Email can't be blank"
        }
    } else if (!baseValidations.IsValidEmail(data)) {
        return {
            isValid: false,
            errorMessage: 'Email not found'
        }
    } else {
        return {
            isValid: true,
            errorMessage: "Email can't be blank"
        }
    }
}
